import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M75.982 20.57a4.5 4.5 0 0 0-2.9 1.858L39.205 71.055 22.99 56.637a4.5 4.5 0 0 0-6.353.373 4.5 4.5 0 0 0 .373 6.353l20 17.782a4.5 4.5 0 0 0 6.681-.79l36.776-52.783a4.5 4.5 0 0 0-1.121-6.263 4.5 4.5 0 0 0-3.364-.739" />
  </svg>
);
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
